import { render, staticRenderFns } from "./SystemProjectTable.vue?vue&type=template&id=4e32c9d2&"
import script from "./SystemProjectTable.vue?vue&type=script&lang=js&"
export * from "./SystemProjectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports